<template>
  <div class="w-full overflow-hidden rounded mx-auto">
    <Chats />
  </div>
</template>

<script>
import Chats from "./components/Chats.vue";
import moduleWhatsappChat from "./store/chat/moduleChat";
import moduleAssignedChat from "./store/assigned-chat/moduleAssignedChat";

export default {
  name: "Home",
  components: {
    Chats,
  },

  created() {
    this.$store.registerModule("whatsappChat", moduleWhatsappChat);
    this.$store.registerModule("assignedChat", moduleAssignedChat);
  },
};
</script>
